import { render } from "./CustomSearch.vue?vue&type=template&id=6fea08bf&ts=true"
import script from "./CustomSearch.vue?vue&type=script&lang=ts"
export * from "./CustomSearch.vue?vue&type=script&lang=ts"

import "./CustomSearch.vue?vue&type=style&index=0&id=6fea08bf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__